import React, { useState } from 'react'
import { useCurrentFolderInfo } from './hooks'
import { Box, Button, TextField } from '@mui/material'
import { openTab } from '../Helpers'
import { OutlinedButton } from 'shared/ui'
import { BorderedContainer } from '../utility/Containers'

export function CurrentFolder() {
  const [changingFolder, setChangingFolder] = useState(false)
  const [newFolderId, setNewFolderId] = useState('')
  const { isRoot, name, setToRoot, setId, folderId, isFolder } =
    useCurrentFolderInfo()

  const setRoot = () => {
    setToRoot()
    setChangingFolder(false)
  }

  const changeFolderId = () => {
    setId(newFolderId)
    setChangingFolder(false)
    setNewFolderId('')
  }

  const folderUrl = `https://drive.google.com/drive/folders/${folderId}`
  const isRootText = isRoot ? '(Root) ' : ''
  return (
    <BorderedContainer>
      <Box>
        Current Folder: {`${isRootText}${name}`}
        <Button onClick={() => openTab(folderUrl)} disabled={!isFolder}>
          Open
        </Button>
      </Box>
      <Box>{!isFolder && name && 'This is not a Google Drive Folder'}</Box>
      <Box>
        <OutlinedButton onClick={() => setChangingFolder(!changingFolder)}>
          Change Folder
        </OutlinedButton>
        {!isRoot && (
          <OutlinedButton onClick={setRoot}>Set To Root</OutlinedButton>
        )}
        {changingFolder && (
          <>
            <TextField
              value={newFolderId}
              onChange={(e) => setNewFolderId(e.target.value)}
            />
            <Button onClick={changeFolderId}>Change</Button>
          </>
        )}
      </Box>
    </BorderedContainer>
  )
}
